import React from 'react';
import { Avatar, SxProps } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { useL2DTheme } from '@europrocurement/flexy-components';
import {
    type DocumentColor,
    type DocumentIconType,
} from '../../../hooks/useDossierDocumentFilesApi';

export type DocumentIconProps = {
    icon: DocumentIconType | 'file-arrow-down' | 'cloud-arrow-down';
    color?: DocumentColor;
    transparentBackground?: boolean;
    sx?: SxProps;
};

const DocumentIcon: React.FunctionComponent<DocumentIconProps> = function (props) {
    const { icon, color = 'secondary', transparentBackground = false, sx } = props;
    const { palette } = useL2DTheme();
    const iconToken = palette.icon?.[color];

    const avatarSx = {
        display: 'flex',
        borderRadius: '8px',
        backgroundColor: transparentBackground ? 'transparent' : iconToken?.backgroundColor,
        minHeight: '36px',
        minWidth: '36px',
        ...sx,
    };

    const avatarIconSx = {
        fontSize: '16px',
        lineHeight: '16px',
        fontWeight: '400',
        color: iconToken?.textColor,
    };

    return (
        <Avatar
            data-testid="document-icon"
            sx={avatarSx}
        >
            <FaOptionIcon
                icon={['fasl', icon]}
                sx={avatarIconSx}
            />
        </Avatar>
    );
};

export default DocumentIcon;
